/**
 * Input Mode Detection
 * Tracks whether user is interacting via mouse or keyboard (Tab key)
 * Adds/removes 'using-mouse' class on document.body for accessibility styling
 */
function initInputModeDetection() {
  let isUsingMouse = false;

  const setMouseMode = () => {
    if (!isUsingMouse) {
      isUsingMouse = true;
      document.body.classList.add('using-mouse');
    }
  };

  const setKeyboardMode = (e: KeyboardEvent) => {
    if (e.key === 'Tab' && isUsingMouse) {
      isUsingMouse = false;
      document.body.classList.remove('using-mouse');
    }
  };

  document.body.addEventListener('mousedown', setMouseMode);
  document.body.addEventListener('keydown', setKeyboardMode);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInputModeDetection);
} else {
  initInputModeDetection();
}
